/**
 * A host names a box family: the exact id, or that id with one record's uuid
 * appended (`coursework-<course uuid>`). A sibling family sharing the prefix
 * (`coursework-rules-<uuid>`) never hosts it.
 */
export function hostsVisit(boxId: string | undefined, host: string): boolean {
  if (!boxId) return false;
  if (boxId === host) return true;
  return boxId.startsWith(`${host}-`) && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(boxId.slice(host.length + 1));
}
